import React, { useCallback } from 'react';
import { enqueueSnackbar } from 'notistack';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconButton } from '@mui/material';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';

export default function CopyDataButton({ value }) {
  const handleCopy = useCallback(() => {
    enqueueSnackbar('Copied!', { variant: 'success' });
  }, []);

  return (
    <CopyToClipboard text={value} onCopy={handleCopy}>
      <IconButton size='small' color='primary' aria-label='copy'>
        <FileCopyOutlinedIcon fontSize='small' />
      </IconButton>
    </CopyToClipboard>
  );
}
